module.exports = __webpack_public_path__ + "static/media/munch2.08b3f651.wav";